import styled from 'styled-components';
import React from "react";

// export default (status) => {
//   console.log("Currently: ",status)
//   styled.div`
//   width: 26rem;
//   position: absolute;
//   left: 1px;
//   top: 0.7rem;
//   bottom: -0.5rem;
//   border-top: 4px dashed #00A154;
// `;
// }

export default styled(({ children, status, ...rest }) => <div {...rest} children={children} />)`
  width: ${({status}) => (status === 'pending' || status === undefined || status === null ? '33%' : '69%')};
  position: absolute;
  left: 1px;
  top: 0.7rem;
  bottom: ${({status}) => (status === 'pending' || status === undefined || status === null ? '-0.5rem' : '4.9rem')};
  border-top: 4px dashed #00A154;
`;
